import React from 'react';
import { TrendingUp } from 'react-feather';
import i18next from 'i18next';

import CollapsibleCard from '../common/CollapsibleCard';
import { SafeNewTabLink, TutorialLinkGroup } from './helpers';

import facebookLinkImage from '../../../assets/images/getting-started/order-food-button.png';
import googleOrderLinkImage from '../../../assets/images/getting-started/google-maps-order-link.png';
import BannerImage from '../../../assets/images/otostolik-square-banner.png';
import type { NormalizedRestaurant } from 'types';

type HowToGetMoreOrdersProps = {
  restaurant: NormalizedRestaurant;
};

const HowToGetMoreOrders: React.FC<HowToGetMoreOrdersProps> = ({ restaurant }) => {
  const { slug } = restaurant;

  const fbTutorialsLink = `https://drive.google.com/file/d/1jXWcabaskEqFUuoptMXIgc14Ks9vUZyJ/view`;
  const googleMapsTutorialLink = 'https://drive.google.com/open?id=1gxMcoBz1RhV0mC0Cmooe0K4RgaPLUxNH';

  const fbShopNowButtonLink
    = `https://otostolik.pl/zamawiaj/${slug}?utm_source=facebook&utm_medium=shop_now_button`;
  const googleMapsShopNowLink = `https://otostolik.pl/zamawiaj/${slug}?utm_source=google_maps`;

  return <>
    <CollapsibleCard title={<div><TrendingUp /> <span>{i18next.t('how-to-get-more-orders.title')}</span></div>}>
      <h4>{i18next.t('how-to-get-more-orders.step1-title')}</h4>
      <TutorialLinkGroup
        img={facebookLinkImage}
        label={i18next.t('how-to-get-more-orders.step1-label')}
        len="30 sec"
        tutorialLink={fbTutorialsLink}
        valueLink={fbShopNowButtonLink}
      />
      <h4>{i18next.t('how-to-get-more-orders.step2-title')}</h4>
      <TutorialLinkGroup
        img={googleOrderLinkImage}
        label={i18next.t('how-to-get-more-orders.step2-label')}
        len="1 min"
        tutorialLink={googleMapsTutorialLink}
        valueLink={googleMapsShopNowLink}
      />
      <h4 className="mt-5">{i18next.t('how-to-get-more-orders.step3-title')}</h4>
      <div>
        <p>{i18next.t('how-to-get-more-orders.step3-hint')}</p>
        <p>{i18next.t('how-to-get-more-orders.step3-use-graphic-prefix')} <SafeNewTabLink url={BannerImage}>{i18next.t('how-to-get-more-orders.step3-use-graphic-link')}:</SafeNewTabLink></p>
        <img src={BannerImage} alt={i18next.t('how-to-get-more-orders.banner-alt')} className="mw-200" />
        <div className="mt-3">{i18next.t('how-to-get-more-orders.step3-custom-graphic')}</div>
        <p>{i18next.t('how-to-get-more-orders.step3-use-logo')}</p>
        <div>
          <SafeNewTabLink url="https://cdn.otostolik.pl/img/logo-svg/with-pl-light.svg">{i18next.t('how-to-get-more-orders.logo-orange-svg')}</SafeNewTabLink>
          |
          <SafeNewTabLink url="https://cdn.otostolik.pl/img/logo-svg/with-pl-white.svg">{i18next.t('how-to-get-more-orders.logo-white-svg')}</SafeNewTabLink>
          |
          <SafeNewTabLink url="https://cdn.otostolik.pl/img/logo-png/with-pl-light.png">{i18next.t('how-to-get-more-orders.logo-orange-png')}</SafeNewTabLink>
          |
          <SafeNewTabLink url="https://cdn.otostolik.pl/img/logo-png/with-pl-white.png">{i18next.t('how-to-get-more-orders.logo-white-png')}</SafeNewTabLink>
        </div>
      </div>
    </CollapsibleCard>
  </>;
}

export default HowToGetMoreOrders;
